import React, { useEffect } from 'react';
import { VStack, HStack } from '@chakra-ui/react';
import { HookFormInput } from '@olo-web/components/molecules/HookFormInput/HookFormInput.ui';
import { useFormContext } from 'react-hook-form';
import { IndicatesRequired } from '@olo-web/components/atoms/IndicatesRequired';

const checkoutFormInputStyles = {
  '.chakra-form__label': {
    fontSize: '12px',
    fontWeight: '400',
    color: 'black',
  },
  '.chakra-form__error-message': {
    fontSize: '12px',
    fontWeight: '400',
    color: 'danger.400',
  },
  '.chakra-input': {
    fontSize: '16px',
    fontWeight: '400',
    color: 'black',
    borderColor: 'black',
  },
};
export function ContactInfoForm(props): JSX.Element {
  const { register, errors, control, formState, setValue, getValues } = useFormContext();
  const { firstName, lastName, email, phoneNo } = props;
  useEffect(() => {
    const values = getValues();
    if (!Object.keys(values).some((k) => values[k])) {
      setValue('firstName', firstName);
      setValue('lastName', lastName);
      setValue('email', email);
      setValue('phoneNo', phoneNo);
    }
  }, [firstName, lastName, email, phoneNo, getValues, setValue]);

  return (
    <>
      <VStack mb={4} spacing={4} align="stretch" w="100%" sx={checkoutFormInputStyles}>
        <IndicatesRequired />
        <HStack spacing={4} w="100%" align="start">
          <HookFormInput
            isRequired
            formState={formState}
            label="First name"
            type="text"
            autoComplete="given-name"
            errors={errors}
            name="firstName"
            ref={register}
            aria-label="First name"
            data-testid="info-form-first-name"
          />
          <HookFormInput
            isRequired
            formState={formState}
            label="Last name"
            type="text"
            autoComplete="family-name"
            errors={errors}
            name="lastName"
            aria-label="Last name"
            ref={register}
            data-testid="info-form-last-name"
          />
        </HStack>
        <HookFormInput
          isRequired
          formState={formState}
          label="Email"
          type="email"
          autoComplete="email"
          errors={errors}
          name="email"
          ref={register}
          data-testid="info-form-email"
          aria-label="Email"
        />
        <HookFormInput
          isRequired
          formState={formState}
          label="Phone number"
          type="tel"
          autoComplete="tel"
          errors={errors}
          name="phoneNo"
          placeholder="(555) 555-5555"
          control={control}
          data-testid="info-form-phone"
          aria-label="Phone number"
        />
      </VStack>
    </>
  );
}
